import { createHowl, soundObjectToArray } from "@/mixins/sound-fx";

export default {
	state: {
		current: {
			component: "AssetLoader",
			settings: {},
			stageIndex: 0,
		},
	},
	actions: {
		loadTutorial(context) {
			context.commit("updateView", {
				component: "Tutorial",
				settings: {
					stage: context.getters.currentStageSettings,
				},
			});
			context.dispatch("playSwoosh");
		},
		loadAssetLoader(context) {
			context.dispatch("loadView", { view: "AssetLoader" });
		},
		loadIntroScreen(context) {
			context.dispatch("loadView", { view: "IntroScreen" });
		},
		loadView(context, payload) {
			context.commit("updateView", {
				component: payload.view,
			});
			context.dispatch("playSwoosh");
		},
		loadStage(context) {
			if ("intro" in context.getters.currentStageSettings) {
				context.dispatch("loadStageIntro");
			} else {
				context.dispatch("loadGameBoard");
			}
			context.dispatch("playSwoosh");
		},
		loadNextStage(context) {
			const stingerSrc = soundObjectToArray(context.getters.currentStageSettings.ending_stinger);
			const musicSrc = soundObjectToArray(context.getters.currentStageSettings.music);

			const stinger = createHowl(stingerSrc);

			context.commit("increaseGameStageIndex");

			const music = createHowl(musicSrc, {
				loop: true,
			});

			context.dispatch("transitionMusic", { stinger, music });
			context.dispatch("loadStage");
		},
		loadStageIntro(context) {
			context.commit("updateView", {
				component: "StageIntro",
				settings: context.getters.currentStageSettings,
			});
			context.dispatch("playSwoosh");
		},
		loadGameBoard(context) {
			context.commit("updateView", {
				component: "GameStage",
				settings: {
					stage: context.getters.currentStageSettings,
				},
			});
		},
		loadGameOver(context) {
			context.dispatch("loadView", {
				view: "GameOver",
			});
		},
	},
	mutations: {
		increaseGameStageIndex(state) {
			state.current.stageIndex += 1;
		},
		updateView(state, payload) {
			state.current.component = payload.component;

			if (payload.settings) {
				state.current.settings = payload.settings;
			} else {
				state.current.settings = {};
			}
		},
	},
	getters: {
		currentStageSettings(state, getters, rootState) {
			return rootState.config.stages[state.current.stageIndex];
		},
		previousStageSettings(state, getters, rootState) {
			let settings = {};
			const previousIndex = state.current.stageIndex - 1;

			if (previousIndex >= 0) {
				settings = rootState.config.stages[previousIndex];
			}

			return settings;
		},
		isLastStage(state, getters, rootState) {
			return rootState.config.stages.length <= state.current.stageIndex;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/views.js